// @mui
import Link from '@mui/material/Link';
import ListItemText from '@mui/material/ListItemText';
import { Link as RouterLink } from '@tyro/router/components';
import { forwardRef } from 'react';

import { ChevronRightIcon } from '@tyro/icons';
import type { NavItemProps } from '../types';
import { StyledIcon, StyledItem } from './styles';

const NavItem = forwardRef<HTMLDivElement, NavItemProps>(
  ({ item, depth, open, active, isExternalLink, ...other }, ref) => {
    const { title, path, icon, children } = item;

    const subItem = depth !== 1;

    const renderContent = (
      <StyledItem
        ref={ref}
        open={open}
        depth={depth}
        active={active}
        {...other}
      >
        {icon && <StyledIcon>{icon}</StyledIcon>}

        <ListItemText
          primary={title}
          slotProps={{
            primary: {
              noWrap: true,
              sx: {
                width: 72,
                fontSize: 10,
                lineHeight: '16px',
                textAlign: 'center',
                ...(active && {
                  fontWeight: 'fontWeightMedium',
                }),
                ...(subItem && {
                  fontSize: 14,
                  width: 'auto',
                  textAlign: 'left',
                }),
              },
            },
          }}
        />

        {/* {caption && (
          <Tooltip title={translate(caption)} arrow placement="right">
            <Iconify
              icon="eva:info-outline"
              width={16}
              sx={{
                top: 11,
                left: 6,
                position: 'absolute',
              }}
            />
          </Tooltip>
        )} */}

        {!!children && (
          <ChevronRightIcon
            sx={{
              width: 20,
              height: 20,
              top: 9,
              right: 3,
              position: 'absolute',
            }}
          />
        )}
      </StyledItem>
    );

    const renderItem = () => {
      // ExternalLink
      if (isExternalLink)
        return (
          <Link href={path} target="_blank" rel="noopener" underline="none">
            {renderContent}
          </Link>
        );

      if (children) return renderContent;

      // Default
      return (
        <Link component={RouterLink} to={path ?? ''} underline="none">
          {renderContent}
        </Link>
      );
    };

    return renderItem();
  },
);

if (process.env.NODE_ENV === 'development') {
  NavItem.displayName = 'NavItem';
}

export default NavItem;
